module.exports = __webpack_public_path__ + "static/media/icon_violencia.37e6f00f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_violencia.svg
// module id = 528
// module chunks = 0